export default __webpack_public_path__ + "static/media/circle-warning-icon.dfc360f8.svg";